<template>
	<div>
		<div style="font-size: 30px; padding: 10px 0;">{{ $route.meta.title }}</div>
		<div class="bg-white padding-lr-lg padding-top-xl padding-bottom-lg">
			<Steps :current="step">
				<Step title="下单" :content="info.addtime"></Step>
				<Step title="派单" :content="info.pdtime"></Step>
				<Step title="服务确认" :content="info.qrtime"></Step>
				<Step title="开始处理" :content="info.begintime"></Step>
				<Step title="处理完成" :content="info.finishtime"></Step>
				<Step title="确认完成" :content="info.shtime"></Step>
				<Step title="结算" :content="info.jstime"></Step>
			</Steps>
		</div>
		<Row class-name="padding-tb-sm" :gutter="16">
			<Col span="18">
			<div class="bg-white padding-xl">
				<div class="flex justify-between">
					<div class="text-lg flex" style="line-height:40px;">
						<div style="width:100px;" class="text-right">
							<span class="text-grey">订单号：</span>
						</div>
						<div class="padding-left">
							<span class="text-bold text-black text-xxl">{{orderid}}</span>
						</div>
					</div>
					<div class="">
						&nbsp;
						<Button type="warning" size="large" @click="modifyModalShow()" icon="ios-create-outline" v-if="info.stateflag<5">修改</Button>
						&nbsp;
						<Button type="primary" size="large" @click="paidan" icon="ios-contact" v-if="info.stateflag<5">派单给师傅</Button>
						&nbsp;
						<Button type="error" size="large" @click="cancelModalShow=true" icon="ios-trash" v-if="info.stateflag<5">取消/作废</Button>
						&nbsp;
						<Button type="warning" size="large" @click="modalShShow=true" icon="md-checkmark-circle-outline" v-if="info.stateflag==5">订单完成审核</Button>
						&nbsp;
						<Button type="success" size="large" @click="showModalJs()" icon="ios-checkmark-circle-outline" v-if="info.stateflag==6 && info.jsflag==0">订单结算</Button>
					</div>
				</div>
				<Divider />
				<Row class-name="padding-tb-sm">
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">订单类型：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-blue" v-if="info.type=='jcz'">预约检测站</span>
							<span class="text-bold text-cyan" v-else-if="info.type=='mj'">免检</span>
							<span class="text-bold text-red" v-else-if="info.type=='dj'">代驾</span>
						</div>
						</Col>
					</Row>
					</Col>
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">订单状态：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-black">{{state_arr[info.stateflag]}}</span>
						</div>
						</Col>
					</Row>
					</Col>
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">订单来源：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-green" v-if="info.source=='xcx'">小程序</span>
							<span class="text-bold text-black" v-else-if="info.source=='admin'">后台</span>
						</div>
						</Col>
					</Row>
					</Col>
				</Row>
				<Row class-name="padding-tb-sm">
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">订单金额：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-red">{{info.money_str}}</span>
						</div>
						</Col>
					</Row>
					</Col>
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">检测费：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-red">{{info.money_jcf/100}}</span>
						</div>
						</Col>
					</Row>
					</Col>
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">优惠金额：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-red">{{info.money_yh/100}}</span>
						</div>
						</Col>
					</Row>
					</Col>
				</Row>
				<Row class-name="padding-tb-sm">
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">支付状态：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-green" v-if="info.payflag=='1'">已支付</span>
							<span class="text-bold text-red" v-else>未支付</span>
						</div>
						</Col>
					</Row>
					</Col>
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">支付方式：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-red">{{info.paytype}}</span>
						</div>
						</Col>
					</Row>
					</Col>
				</Row>
				<Row class-name="padding-tb-sm" v-if="info.type=='dj'">
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">检测站：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-black" v-if="info.jczinfo">[{{info.jczinfo.province}} - {{info.jczinfo.city}}]
								{{info.jczinfo.name}}</span>
						</div>
						</Col>
					</Row>
					</Col>
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">检测时间：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-black">{{info.date}}</span>
						</div>
						</Col>
					</Row>
					</Col>
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">取还车地址：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-black">{{info.fileds.add_qhc.address}}</span>
						</div>
						</Col>
					</Row>
					</Col>
				</Row>
				<Row class-name="padding-tb-sm" v-if="info.type=='jcz'">
					<Col span="16">
					<Row>
						<Col span="3">
						<div class="text-right">
							<span class="text-grey">检测站：</span>
						</div>
						</Col>
						<Col span="21">
						<div class="text-left padding-left">
							<span class="text-bold text-black">[{{info.jczinfo.province}} - {{info.jczinfo.city}}] {{info.jczinfo.name}}</span>
						</div>
						</Col>
					</Row>
					</Col>
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">检测时间：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-black">{{info.date}}</span>
						</div>
						</Col>
					</Row>
					</Col>
				</Row>
				<Row class-name="padding-tb-sm">
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">下单会员：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-blue" v-if="info.user">{{info.user.nickname}}({{info.user.mobile}})</span>
						</div>
						</Col>
					</Row>
					</Col>
					<Col span="8" v-if="info.tgr">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">推广人：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left ">
							<span class="text-bold text-pink">{{info.tgr.nickname}}({{info.tgr.mobile}})</span>
						</div>
						</Col>
					</Row>
					</Col>
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">服务师傅：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-black" v-if="info.sfinfo">{{info.sfinfo.nickname}}({{info.sfinfo.mobile}})</span>
						</div>
						</Col>
					</Row>
					</Col>
				</Row>
				<Row class-name="padding-tb-sm">
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">下单时间：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-black">{{info.addtime}}</span>
						</div>
						</Col>
					</Row>
					</Col>
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">更新时间：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-black">{{info.updatetime}}</span>
						</div>
						</Col>
					</Row>
					</Col>
				</Row>
				<Row class-name="padding-tb-sm">
					<Col span="2">
					<div class="text-right">
						<span class="text-grey">订单备注：</span>
					</div>
					</Col>
					<Col span="22">
					<div class="text-left padding-left">
						<span class="text-bold text-black">{{info.remark}}</span>
					</div>
					</Col>
				</Row>
				<Divider orientation="left">车辆信息</Divider>
				<Row class-name="padding-tb-sm">
					<Col span="12">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">车牌号码：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-black">{{info.carinfo.plate_num_b}}</span>
						</div>
						</Col>
					</Row>
					</Col>
					<Col span="12">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">使用性质：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-black">{{info.carinfo.use_character}}</span>
						</div>
						</Col>
					</Row>
					</Col>
				</Row>
				<Row class-name="padding-tb-sm">
					<Col span="12">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">座位数：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-black">{{info.carinfo.passengers_num}}</span>
						</div>
						</Col>
					</Row>
					</Col>
					<Col span="12">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">注册日期：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-black">{{info.carinfo.register_date}}</span>
						</div>
						</Col>
					</Row>
					</Col>
				</Row>
				<Divider orientation="left">联系人信息</Divider>
				<Row class-name="padding-tb-sm">
					<Col span="12">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">姓名：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-black">{{info.linkman.name}}</span>
						</div>
						</Col>
					</Row>
					</Col>
					<Col span="12">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">手机：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-black">{{info.linkman.mobile}}</span>
						</div>
						</Col>
					</Row>
					</Col>
				</Row>
				<Row class-name="padding-tb-sm">
					<Col span="12">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">地址：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-black">{{info.linkman.address}}</span>
						</div>
						</Col>
					</Row>
					</Col>
				</Row>
				<Row class-name="padding-tb-sm">
					<Col span="12" v-if="info.carinfo.img_url">
					<Divider orientation="left">行驶证</Divider>
					<div class="flex">
						<div class="padding text-center">
							<div class="imgbox">
								<a :href="'https://cjb.xahulian.com/'+info.carinfo.img_url" target="_blank">
									<img :src="'https://cjb.xahulian.com/'+info.carinfo.img_url" style="height:256px;" />
								</a>
							</div>
						</div>
					</div>
					</Col>
					<Col span="12">
					<div v-if="info.type=='mj'">
						<Divider orientation="left">保单</Divider>
						<div class="flex" v-if="info.fileds.baodan">
							<div class="padding text-center">
								<div class="imgbox">
									<a :href="'https://cjb.xahulian.com/'+info.fileds.baodan" target="_blank">
										<img :src="'https://cjb.xahulian.com/'+info.fileds.baodan" style="height:256px;" />
									</a>
								</div>
							</div>
						</div>
					</div>
					</Col>
				</Row>
				<div v-if="info.reply">
					<Divider orientation="left">处理回执</Divider>
					<div class="flex">
						<div class="padding text-center">
							<div class="padding-tb-sm text-bold text-lg">合格标</div>
							<div class="imgbox">
								<a :href="'https://cjb.xahulian.com/'+info.reply.hgz" target="_blank">
									<img :src="'https://cjb.xahulian.com/'+info.reply.hgz" style="width:256px;" />
								</a>
							</div>
						</div>
						<div class="padding text-center">
							<div class="padding-tb-sm text-bold text-lg">行驶证</div>
							<div class="imgbox">
								<a :href="'https://cjb.xahulian.com/'+info.reply.xsz" target="_blank">
									<img :src="'https://cjb.xahulian.com/'+info.reply.xsz" style="width:256px;" />
								</a>
							</div>
						</div>
						<div class="padding text-center">
							<div class="padding-tb-sm text-bold text-lg">保单</div>
							<div class="imgbox">
								<a :href="'https://cjb.xahulian.com/'+info.reply.bd" target="_blank">
									<img :src="'https://cjb.xahulian.com/'+info.reply.bd" style="width:256px;" />
								</a>
							</div>
						</div>
						<div class="padding text-center">
							<div class="padding-tb-sm text-bold text-lg">车辆照片</div>
							<div class="imgbox">
								<a :href="'https://cjb.xahulian.com/'+info.reply.car" target="_blank">
									<img :src="'https://cjb.xahulian.com/'+info.reply.car" style="width:256px;" />
								</a>
							</div>
						</div>
					</div>
				</div>
				<div v-if="info.stateflag>=5">
					<Divider orientation="left">客户评价</Divider>
					<div v-if="info.rate">
						<div class="flex">
							<div class="text-bold">评分：</div>
							<Rate disabled v-model="info.rate.rank" show-text />
						</div>
						<div class="">
							<div class="text-bold">评价：</div>
							<div class="padding">
								{{info.rate.content}}
							</div>
						</div>
					</div>
					<div class="padding" v-else>
						<Button type="warning" v-if="info.source=='admin'" @click="rateModalShow=true">
							添加评价
						</Button>
					</div>
				</div>
			</div>
			</Col>
			<Col span="6">
			<div class="bg-white padding-xl">
				<div class="padding-top-sm padding-bottom-xs text-xxl text-bold">订单日志</div>
				<Divider />
				<div style="position: relative;">
					<Timeline>
						<TimelineItem v-for="item in logs.infos">
							<p class="time text-bold text-blue">{{item.time}}</p>
							<p class="content">{{item.text}}</p>
						</TimelineItem>
					</Timeline>
					<Page :total="logs.total" :page-size="logs.size" :current="logs.page" show-total @on-change="loadlogs(e)" />
					<Spin fix v-if="loading_logs">
						<Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
						<div>加载中...</div>
					</Spin>
				</div>
			</div>
			</Col>
		</Row>

		<Modal v-model="paidanShow" title="给师傅派单" @on-ok="paidanSubmit" @on-cancel="paidanShow=false" :footer-hide="true"
		 :width="1000">
			<div style="position: relative;">
				<Table :data="sfList" :columns="sfColumns" size="large" border :loading="sfLoading" no-data-text="当前订单无可派单的师傅">
					<template slot-scope="{ row }" slot="action">
						<Button type="primary" @click="paidanSubmit(row.uid)">
							派单
							<Icon type="ios-arrow-forward" />
						</Button>
					</template>
				</Table>
			</div>
		</Modal>
		<Modal v-model="rateModalShow" title="订单评价" :footer-hide="true" :width="520">
			<div style="position: relative;">
				<Form ref="formOrderAdd" :model="formOrderRate" label-position="right" :label-width="100" label-colon>
					<FormItem label="评分">
						<Rate show-text allow-half v-model="formOrderRate.rank">
							<span style="color: #f5a623">{{ formOrderRate.rank }}</span>
						</Rate>
					</FormItem>
					<FormItem label="评价内容">
						<Input v-model="formOrderRate.content" type="textarea" :rows="5" show-word-limit :maxlength="140" placeholder="评价内容"></Input>
					</FormItem>
					<Divider />
					<FormItem>
						<Button type="primary" @click="rateSubmit('formOrderRate')" :loading="orderRateLoading" icon="ios-add">提交</Button>
						<Button style="margin-left: 8px" @click="rateModalShow=false">取消</Button>
					</FormItem>
				</Form>
			</div>
		</Modal>
		<Modal v-model="cancelModalShow" title="取消订单" :footer-hide="true" :width="520">
			<div style="position: relative;">
				<Form ref="formOrderCancel" :model="formOrderCancel" label-position="right" :label-width="100" label-colon>
					<FormItem label="取消原因">
						<Select v-model="formOrderCancel.reason" clearable>
							<Option value="user">客户</Option>
							<Option value="car">车辆</Option>
							<Option value="other">其他</Option>
						</Select>
					</FormItem>
					<FormItem label="备注说明">
						<Input v-model="formOrderCancel.content" type="textarea" :rows="5" show-word-limit :maxlength="140" placeholder="备注说明"></Input>
					</FormItem>
					<Divider />
					<FormItem>
						<Button type="primary" @click="cancelSubmit('formOrderCancel')" :loading="orderCancelLoading" icon="ios-add">提交</Button>
						<Button style="margin-left: 8px" @click="cancelModalShow=false">取消</Button>
					</FormItem>
				</Form>
				<Spin fix v-if="orderCancelLoading">
					<Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
					<div>处理中...</div>
				</Spin>
			</div>
		</Modal>
		<Modal v-model="showModalModify" title="修改订单内容" @on-ok="orderAddSubmit('formOrderAdd')" :mask-closable="false"
		 footer-hide>
			<div style="position: relative;" class="padding-left padding-right-xl">
				<Form ref="formOrderModify" :model="formOrderModify" label-position="right" :label-width="100" label-colon>
					<FormItem label="订单类型">
						<span class="text-blue" v-if="formOrderModify.type=='jcz'">检测站</span>
						<span class="text-blue" v-else-if="formOrderModify.type=='mj'">免检</span>
						<span class="text-blue" v-else-if="formOrderModify.type=='dj'">代驾</span>
					</FormItem>
					<FormItem label="检测站">
						<Select v-model="formOrderModify.jcz" filterable clearable>
							<Option v-for="item in jczList" :key="item.id" :value="item.id">[{{item.id}}{{item.province}}-{{item.city}}] {{item.name}}</Option>
						</Select>
					</FormItem>
					<FormItem label="检测时间" v-if="formOrderModify.type!='mj'">
						<DatePicker type="date" format="yyyy-MM-dd" placeholder="选择日期" @on-change="jc_date" :value="info.date"></DatePicker>
					</FormItem>
					<FormItem label="取还车地址" v-if="formOrderModify.type=='dj'">
						<Input type="textarea" v-model="formOrderModify.fileds.add_qhc.address" :rows="2"></Input>
					</FormItem>
					<Divider orientation="left">车辆信息</Divider>
					<FormItem label="车牌号码">
						<Input v-model="formOrderModify.carinfo.plate_num_b" maxlength="8" style="width:150px;"></Input>
					</FormItem>
					<FormItem label="使用性质">
						<RadioGroup v-model="formOrderModify.carinfo.use_character">
							<Radio label="非营运" checked>非营运</Radio>
							<Radio label="营运">营运</Radio>
						</RadioGroup>
					</FormItem>
					<FormItem label="座位数">
						<Select v-model="formOrderModify.carinfo.passengers_num" clearable>
							<Option value="4">5座以下</Option>
							<Option value="5">5座</Option>
							<Option value="6">6座</Option>
							<Option value="7">7座</Option>
							<Option value="8">7座以上9座及以下</Option>
							<Option value="10">9座以上</Option>
						</Select>
					</FormItem>
					<FormItem label="注册日期">
						<DatePicker type="date" format="yyyy-MM-dd" @on-change="register_date" placeholder="选择注册日期" :value="formOrderModify.carinfo.register_date"></DatePicker>
					</FormItem>
					<Tabs value="name1" type="card">
						<TabPane label="联系信息" name="name1">
							<FormItem label="姓名">
								<Input v-model="formOrderModify.linkman.name" maxlength="18" style="width:150px;"></Input>
							</FormItem>
							<FormItem label="手机">
								<Input v-model="formOrderModify.linkman.mobile" maxlength="11" show-word-limit style="width:200px;"></Input>
							</FormItem>
							<FormItem label="地址" v-if="formOrderModify.type=='mj'">
								<Input type="textarea" v-model="formOrderModify.linkman.address" :rows="2"></Input>
							</FormItem>
						</TabPane>
						<TabPane label="金额信息" name="name2">
							<FormItem label="订单金额">
								<Input v-model="formOrderModify.money" style="width:120px;"></Input>
							</FormItem>
							<FormItem label="优惠金额">
								<Input v-model="formOrderModify.money_yh" style="width:120px;"></Input>
							</FormItem>
							<FormItem label="支付状态">
								<RadioGroup v-model="formOrderModify.payflag">
									<Radio label="0">未支付</Radio>
									<Radio label="1">已支付</Radio>
								</RadioGroup>
							</FormItem>
						</TabPane>
						<TabPane label="备注信息" name="name3">
							<Input v-model="formOrderModify.remark" type="textarea" :rows="4" placeholder="" maxlength=140 show-word-limit />
						</TabPane>
					</Tabs>
					<Divider />
					<FormItem>
						<Button type="primary" @click="orderModifySubmit('formOrderAdd')" :loading="orderModifyLoading" icon="ios-add">提交</Button>
						<Button style="margin-left: 8px" @click="showModalModify=false">取消</Button>
					</FormItem>
				</Form>
			</div>
		</Modal>
		<!--订单完成审核-->
		<Modal v-model="modalShShow" title="订单完成审核" ok-text="确认完成" @on-ok="orderSh()" :mask-closable="0" :loading="loadingSh" :width="450">
			<div style="position: relative;" class="padding-lr">
				<div>
					<div class="padding-bottom">
						<Alert type="error">
							<Icon type="ios-alert-outline" /> <span class="text-red">请确认订单已经完成。</span>
						</Alert>
					</div>
				</div>
		
				<Spin fix v-if="loadingSh">
					<Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
					<div>处理中...</div>
				</Spin>
			</div>
		</Modal>
		
		<Modal v-model="modalJsShow" title="订单结算" :footer-hide="true" :width="430">
			<div style="position: relative;" class="padding-lr">
				<div class="padding-xl text-red text-lg" v-if="formJs.msg">
					<Icon type="ios-alert-outline" /> {{formJs.msg}}
				</div>
				<div v-else>
					<div class="padding-bottom">
						<Alert type="error">
							<Icon type="ios-alert-outline" /> <span class="text-red">请确认订单已经完成后再进行结算。</span>
						</Alert>
					</div>
					<Form ref="formJs" :model="formJs" label-position="right" :label-width="100" label-colon>
						<FormItem label="师傅提成">
							<Input v-model="formJs.sfyj" placeholder="单位:元" style="width:210px" /> 元
						</FormItem>
						<div v-if="formJs.tg">
							<Divider orientation="left">推广分成</Divider>
							<FormItem label="一级分成" v-if="formJs.tg.yj">
								<Input v-model="formJs.tg.yj.score" placeholder="整数,不支持小数" style="width:210px" /> 积分
								<div class="flex padding-top-sm">
									<div class=" padding-top-xs">
										<Avatar :src="'http://cjb.xahulian.com/'+ formJs.tg.yj.user.avatar " size="48" v-if="formJs.tg.yj.user.avatar" />
										<Avatar icon="ios-person" size="48" v-else />
									</div>
									<div class="padding-left-sm padding-top-xs text-left" style="line-height:25px">
										<span class="text-lg">{{formJs.tg.yj.user.nickname}}</span><br />
										<span class="text-blue">{{formJs.tg.yj.user.mobile}}</span>
									</div>
								</div>
							</FormItem>
							<FormItem label="二级分成" v-if="formJs.tg.ej">
								<Input v-model="formJs.tg.ej.score" placeholder="整数,不支持小数" style="width:210px" /> 积分
								<div class="flex padding-top-sm">
									<div class=" padding-top-xs">
										<Avatar :src="'http://cjb.xahulian.com/'+ formJs.tg.ej.user.avatar " size="48" v-if="formJs.tg.ej.user.avatar" />
										<Avatar icon="ios-person" size="48" v-else />
									</div>
									<div class="padding-left-sm padding-top-xs text-left" style="line-height:25px">
										<span class="text-lg">{{formJs.tg.ej.user.nickname}}</span><br />
										<span class="text-blue">{{formJs.tg.ej.user.mobile}}</span>
									</div>
								</div>
							</FormItem>
						</div>
						<Divider />
						<FormItem>
							<Button type="primary" @click="submitFormJs('formJs')">提交</Button>
							<Button style="margin-left: 8px" @click="modalJsShow=false">取消</Button>
						</FormItem>
					</Form>
				</div>

				<Spin fix v-if="loadingJs">
					<Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
					<div>处理中...</div>
				</Spin>
			</div>
		</Modal>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				paidanShow: false,
				state_arr: [],
				jczList:[],
				orderid: '',
				step:0,
				info: {
					carinfo: {},
					linkman: {}
				},
				rank: 1,
				sfLoading: false,
				sfList: [],
				sfColumns: [{
						title: '序号',
						type: 'index',
						align: 'center',
						width: 75
					},
					{
						title: '姓名',
						key: 'nickname',
						align: 'center'
					},
					{
						title: '手机',
						key: 'mobile',
						align: 'center',
						width: 140
					},
					{
						title: '服务站点',
						key: 'zhandian',
						align: 'left',
						width: 300
					},
					{
						title: '订单数',
						key: 'total_order',
						align: 'center'
					},
					{
						title: '评分',
						key: 'rate',
						align: 'center'
					},
					{
						title: '选择',
						align: 'center',
						slot: 'action'
					}
				],
				rateModalShow: false,
				orderRateLoading: false,
				formOrderRate: {
					orderid: '',
					rank: 0,
					content: ''
				},
				cancelModalShow: false,
				orderCancelLoading: false,
				formOrderCancel: {
					reason: 'user',
					content: ''
				},
				showModalModify: false,
				orderModifyLoading: false,
				formOrderModify: {
					carinfo: {},
					linkman: {}
				},
				logs: {
					page: 1,
					size: 10,
					total: 0,
					infos: []
				},
				loading_logs: false,
				modalShShow:false,
				loadingSh: false,
				formSh: {
					orderid: '',
					content:''
				},
				modalJsShow: false,
				loadingJs: false,
				formJs: {
					"msg": '',
					sfyj: 0,
					tg: {
						yj: {
							score: 0,
							user: {}
						},
						ej: {
							score: 0,
							user: {}
						}
					}
				}
			};
		},
		methods: {
			loadinfo() {
				let postData = {
					orderid: this.orderid
				};
				this.$http.post('/server/api/order/index.php?a=view', this.$qs.stringify(postData)).then(
					res => {
						if (res.data.result == 'ok') {
							//this.$Message.success('获取成功!');
							this.jczList = res.data.data.jczList;
							this.state_arr = res.data.data.state_arr;
							this.info = res.data.data.info;
							if(res.data.data.info.stateflag<2) this.step=0;
							else if(res.data.data.info.stateflag==2) this.step=1;
							else if(res.data.data.info.stateflag==3) this.step=2;
							else if(res.data.data.info.stateflag==4) this.step=3;
							else if(res.data.data.info.stateflag==5) this.step=4;
							else if(res.data.data.info.stateflag==6 && !res.data.data.info.jsflag) this.step=5;
							else if(res.data.data.info.stateflag==6 && res.data.data.info.jsflag) this.step=6;
							this.loadlogs();
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.$Message.error('系统错误');
					}
				);
			},
			loadlogs(e){
				console.log(e)
			},
			loadlogs() {
				this.loading_logs = true;
				let postData = {
					page: this.logs.page,
					size: this.logs.size,
					orderid: this.orderid
				};
				this.$http.post('/server/api/order/index.php?a=getlogs', this.$qs.stringify(postData)).then(
					res => {
						this.loading_logs = false;
						if (res.data.result == 'ok') {
							this.logs = res.data.data;
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loading_logs = false;
						this.$Message.error('系统错误');
					}
				);
			},
			modifyModalShow() {
				this.formOrderModify = this.info;
				this.showModalModify = true;
			},
			jc_date(date) {
				this.formOrderModify.date = date;
			},
			register_date(date) {
				this.formOrderModify.carinfo.register_date = date;
			},
			orderModifySubmit(name) {
				this.orderModifyLoading = true;
				this.formOrderModify.orderid = this.orderid;
				this.$http.post('/server/api/order/index.php?a=modify', this.$qs.stringify(this.formOrderModify)).then(
					res => {
						this.orderModifyLoading = false;
						if (res.data.result == 'ok') {
							this.$Message.success('操作成功!');
							this.loadinfo();
							this.showModalModify = false;
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.orderModifyLoading = false;
						this.$Message.error('系统错误');
					}
				);
			},
			paidan() {
				this.paidanShow = true;
				this.sfLoading = true;
				let postData = {
					orderid: this.orderid
				};
				this.$http.post('/server/api/order/index.php?a=getsflist', this.$qs.stringify(postData)).then(
					res => {
						this.sfLoading = false;
						if (res.data.result == 'ok') {
							//this.$Message.success('获取成功!');
							this.sfList = res.data.data.sfList;
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.sfLoading = false;
						this.$Message.error('系统错误');
					}
				);
			},
			paidanSubmit(uid) {
				let postData = {
					orderid: this.orderid,
					sf: uid
				};
				this.$http.post('/server/api/order/index.php?a=paidan', this.$qs.stringify(postData)).then(
					res => {
						if (res.data.result == 'ok') {
							this.$Message.success('派单成功!');
							this.info.stateflag = 2;
							this.info.sfinfo = res.data.data.sfinfo;
							this.paidanShow = false;
							this.loadinfo();
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.$Message.error('系统错误');
					}
				);
			},
			rateSubmit(name) {
				this.formOrderRate.orderid = this.orderid;
				this.formOrderRate.sf = this.info.sf;
				this.$http.post('/server/api/order/index.php?a=rate', this.$qs.stringify(this.formOrderRate)).then(
					res => {
						if (res.data.result == 'ok') {
							this.$Message.success('评价成功!');
							this.info.rate = this.formOrderRate;
							this.rateModalShow = false;
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.$Message.error('系统错误');
					}
				);
			},
			cancelSubmit(name) {
				this.orderCancelLoading = true;
				this.formOrderCancel.orderid = this.orderid;
				this.$http.post('/server/api/order/index.php?a=cancel', this.$qs.stringify(this.formOrderCancel)).then(
					res => {
						this.orderCancelLoading = false;
						if (res.data.result == 'ok') {
							this.$Message.success('取消成功!');
							this.loadinfo();
							this.cancelModalShow = false;
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.orderCancelLoading = false;
						this.$Message.error('系统错误');
					}
				);
			},
			orderSh(){
				this.loadingSh = true;
				this.$http.post('/server/api/order/index.php?a=sh', this.$qs.stringify({orderid:this.orderid})).then(
					res => {
						this.loadingSh = false;
						if (res.data.result == 'ok') {
							this.$Message.success('操作成功!');
							this.modalShShow = false;
							this.loadinfo();
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loadingSh = false;
						this.modalShShow = false;
						this.$Message.error('系统错误');
					}
				);
			},
			showModalJs() {
				this.modalJsShow = true;
				this.loadingJs = true;
				let postData = {
					orderid: this.orderid
				};
				this.formJs.msg = '';
				this.$http.post('/server/api/order/index.php?a=jsset', this.$qs.stringify(postData)).then(
					res => {
						this.loadingJs = false;
						if (res.data.result == 'ok') {
							this.$Message.success('获取成功!');
							this.formJs = res.data.data;
							this.formJs.msg = '';
						} else {
							this.$Message.error(res.data.msg);
							this.formJs.msg = res.data.msg;
						}
					},
					r => {
						this.modalJsShow = false;
						this.$Message.error('系统错误');
					}
				);
			},
			submitFormJs(name){
				this.loadingJs = true;
				this.formJs.orderid = this.orderid;
				this.$http.post('/server/api/order/index.php?a=js', this.$qs.stringify(this.formJs)).then(
					res => {
						this.loadingJs = false;
						if (res.data.result == 'ok') {
							this.$Message.success('操作成功!');
							this.loadinfo();
							this.modalJsShow = false;
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loadingJs = false;
						this.$Message.error('系统错误');
					}
				);
			}
		},
		created() {
			//console.log(this.searchForm)
			this.orderid = this.$route.params.id;
			this.loadinfo();
		}
	};
</script>

<style>
	img {
		display: block;
	}

	.imgbox {
		border: #ddd 1px solid;
		box-shadow: #aaa 0 0 8px;
	}

	.demo-spin-icon-load {
		animation: ani-demo-spin 1s linear infinite;
	}
</style>
